document.addEventListener("DOMContentLoaded", function() {
  // Set tab-2 to hidden by default
  var tab2 = document.getElementById("tab-2");
  if (tab2) tab2.classList.add("hidden");

  // Function to toggle classes based on clicks
  function toggleClasses() {
    // Remove 'active' class from tab-2, specs-head, and mb-two
    if (tab2) tab2.classList.remove("active");
    var specsHead = document.querySelector(".specs-head");
    if (specsHead) specsHead.classList.remove("active");
    var mbTwo = document.querySelector(".mb-two");
    if (mbTwo) mbTwo.classList.remove("active");

    // Add 'active' class to tab-1 and remove from specs-head, mb-two, and tab-2
    var overviewHead = document.querySelector(".overview-head");
    if (overviewHead) overviewHead.classList.add("active");
    var mbOne = document.querySelector(".mb-one");
    if (mbOne) mbOne.classList.add("active");
    if (specsHead) specsHead.classList.remove("active");
    if (mbTwo) mbTwo.classList.remove("active");
    var tab1 = document.getElementById("tab-1");
    if (tab1) tab1.classList.add("active");
  }

  // Add click event listeners to overview-head and mb-one
  var overviewHead = document.querySelector(".overview-head");
  if (overviewHead) overviewHead.addEventListener("click", toggleClasses);
  var mbOne = document.querySelector(".mb-one");
  if (mbOne) mbOne.addEventListener("click", toggleClasses);

  // Add click event listeners to specs-head and mb-two
  var specsHead = document.querySelector(".specs-head");
  if (specsHead) {
    specsHead.addEventListener("click", function() {
      // Remove 'active' class from tab-1, overview-head, and mb-one
      var tab1 = document.getElementById("tab-1");
      if (tab1) tab1.classList.remove("active");
      if (overviewHead) overviewHead.classList.remove("active");
      if (mbOne) mbOne.classList.remove("active");

      // Add 'active' class to tab-2 and remove from overview-head, mb-one, and tab-1
      if (tab2) tab2.classList.add("active");
      if (specsHead) specsHead.classList.add("active");
      var mbTwo = document.querySelector(".mb-two");
      if (mbTwo) mbTwo.classList.add("active");
    });
  }

  if (mbOne) {
    mbOne.addEventListener("click", function() {
      // Logic seems to be repeated or incorrect; adjust as needed
    });
  }

  var mbTwo = document.querySelector(".mb-two");
  if (mbTwo) {
    mbTwo.addEventListener("click", function() {
      // Adjust logic as needed for mb-two click event
    });
  }

  var divContent = document.getElementById("tab-2");
  if (divContent && divContent.innerHTML.trim() !== "") {
      // Add class 'exists' to specs-head and mb-two
      if (specsHead) specsHead.classList.add("exists");
      if (mbTwo) mbTwo.classList.add("exists");
  }

  // jQuery dependent code, ensure jQuery is loaded
  if (window.$) {
    if ($('.swatch .header').text().includes("Color:")) {
      $('.swatch .header').append('<span class="colorlabel"></span>');    
      $('.product-name.top-product-detail h1 a').append('<span class="colorlabel"></span>');
      if ($('.swatch').find("input:checked").length > 0) {
        var color = $('.swatch').find("input:checked").closest('.swatch-element').attr('data-value');
        $('.colorlabel').text(color);
        $('.product-name.top-product-detail h1 a .colorlabel').text(' - '+color);
        console.log(color);
      }
    }
    $('.swatch').on('click', function () {
      var color = $(this).find("input:checked").closest('.swatch-element').attr('data-value');
      $('.colorlabel').text(color);
      $('.product-name.top-product-detail h1 a .colorlabel').text(' - '+color);
      console.log(color);
    });
    $('.level0.menu-wrap-sub a').on("click", function() {
        window.location.replace($(this).attr('href'));
    });
    $('.mob-head').on("click", function() {
      $('.mob-head').removeClass('active');
      $(this).addClass('active');
      $('#stwrapper .content').removeClass('hidden');
      $('#stwrapper .content').removeClass('active');
      $(this).next().removeClass('hidden');
      $(this).next().addClass('active');      
    });
  } else {
    console.error("jQuery is not loaded.");
  }
});